import Vue from 'vue'
import VueRouter from 'vue-router'
import global from '@/utils/global'

Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  name: 'Index',
	  component: () => import('../views/Index'),
	},
	{
	  path: '/m/index',
	  name: 'MIndex',
	  component: () => import('../views/MIndex'),
	},
	{
	  path: '/feedback',
	  name: 'Feedback',
	  component: () => import('../views/Feedback'),
	},
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register'),
  },
  {
    path: '/refresh_token',
    name: 'RefreshToken',
    component: () => import('../views/RefreshToken'),
  },
  {
    path: '/verifyphone',
    name: 'VerifyPhone',
    component: () => import('../views/secure/VerifyPhone'),
  },
  {
    path: '/checkphone',
    name: 'CheckPhone',
    component: () => import('../views/secure/CheckPhone'),
  },
  {
    path: '/reset_password',
    name: 'ResetPassword',
    component: () => import('../views/secure/Reset_password'),
    meta: {
      authorization: true,
    },
  },
  {
    path: '/findpassword',
    name: 'FindPassword',
    component: () => import('../views/secure/FindPassword'),
  },
  {
    path: '/bindmail',
    name: 'BindMail',
    component: () => import('../views/secure/BindMail'),
	meta: {
	  authorization: true,
	},
  },
  {
    path: '/finishreset',
    name: 'FinishReset',
    component: () => import('../views/secure/Finish-reset'),
    meta: {
      authorization: true,
    },
  },
  {
    path: '/',
    redirect: {name: 'Secure'},
    component: () => import('../components/layout/AccountLayout'),
    children: [
      {
        path: 'secure',
        name: 'Secure',
        component: () => import('../views/Secure'),
        meta: {
          authorization: true,
        },
      },
      {
        path: 'basic_info',
        name: 'BasicInfo',
        component: () => import('../views/BasicInfo'),
        meta: {
          authorization: true,
        },
      },
      {
        path: 'authc',
        name: 'Authc',
        redirect: {name: 'AuthcHome'},
        component: () => import('../components/layout/AuthcLayout'),
        children: [
          {
            path: 'home',
            name: 'AuthcHome',
            component: () => import('../views/authc/Home'),
            meta: {
              authorization: true,
            },
          },
		  {
		    path: 'authfinish',
		    name: 'AuthFinish',
		    component: () => import('@/views/authc/AuthFinish'),
		    meta: {
		      authorization: true,
		    },
		  },
          {
            path: 'select',
            name: 'AuthcSelect',
            component: () => import('@/views/authc/Select'),
            meta: {
              authorization: true,
            },
          },
          {
            path: 'user',
            name: 'AuthcUser',
            component: () => import('@/views/authc/User'),
            meta: {
              authorization: true,
            },
          },
          {
            path: 'ent',
            name: 'AuthcEnt',
            component: () => import('@/views/authc/Ent'),
            meta: {
              authorization: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/',
    redirect: {name: 'WholeMessage'},
    component: () => import('../components/layout/MessageLayout'),
    children: [
      {
        path: 'wholemessage',
        name: 'WholeMessage',
        component: () => import('../views/message/WholeMessage'),
        meta: {
          authorization: true,
        },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// 路由守卫
router.beforeEach((to, from, next) => {
  let token = Vue.$cookies.get('token')
  if (to.meta.authorization === true && !token) {
    // 需要登录 当没有token的
    // 记录要去的地址，登录后跳转
    sessionStorage.setItem(global.keys.redirectURIKey, to.path)
    next({name: 'RefreshToken'})
  } else {
    next()
  }
})

export default router
